// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__24yRC","clinicsSelect":"TableHeading_clinicsSelect__20dYO"};